import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { Field, IField } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'custom-choice-chip',
    templateUrl: './choice-chip.component.html',
    styleUrls: ['./choice-chip.component.scss'],
    imports: [CommonModule, MatIcon]
})
export class ChoiceChipComponent implements OnInit {
    @Input() field: any = new Field();
    @Output() callback = new EventEmitter<any>();
    form: FormGroup | undefined;
    selectedOption: string | undefined;

    constructor() {}

    ngOnInit(): void {
        if (this.field.value) {
            this.selectedOption = this.field.value;
            if (!this.field.disabled && !this.field.readonly) {
                this.callback.emit(this.field.value);
            }
        }
    }

    onClick(option: any, $event: MouseEvent) {
        this.selectedOption = option;
        if (!this.field.disabled && !this.field.readonly) {
            this.callback.emit(option);
        }
    }
}
